import React, {Fragment} from 'react';
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router";
import Breadcrumbs from "./Breadcrumbs";

class LayoutTitle extends React.Component {

	render() {
		const {location} = this.props;

		return <Fragment>
			<h2 className={"layout-title--title"}>
				{this.props.title}
			</h2>

			{location.pathname === '/' ? null : (
			<div className={"layout-title--breadcrumb-bar p-l-15 p-r-15 p-t-15 p-b-15 bg--white m-b-20"}>
				<Breadcrumbs/>
				{/*<Icon type="home" style={{fontSize: '1.5em'}} className="m-r-10"/>
				<span className="m-r-10">
					Dashboard
				</span>
				<Button size="small" onClick={this.goBack} className="global--back-button">
					<Icon type="left"/>Back
				</Button>*/}
			</div>)}
		</Fragment>;
	}
}

const mapStateToProps = state => {

	return {
		title: state.global.title
	};
};


export default withRouter(connect(mapStateToProps)(LayoutTitle));
